if(!customerMd5Hash){
      window.location.href = "/";
    } 

// 1. 제품 선택

let ITEMS_PER_PAGE = 6; // 기본값 (PC 기준)
let currentRegisteredPage = 1;
let registeredProductData = [];
let hasRegisteredProductListLoaded = false;
const AS_PROXY_BASE_URL = 'https://sidiz-shopify.sidiz.com';
const CUSTOMER_PROD_VERIFICATION_LIST_ENDPOINT = `${AS_PROXY_BASE_URL}/v1/db/customer-prod-verification-list`;
const SERIAL_REGISTRATION_ENDPOINT = `${AS_PROXY_BASE_URL}/v1/db/serial-registration`;

function normalizeSerial(value) {
  return String(value || '').trim();
}

function resolveRegisteredProductPageBySerial(serialNumber) {
  const serial = normalizeSerial(serialNumber);
  if (!serial || !Array.isArray(registeredProductData) || registeredProductData.length === 0) return 1;

  const serialIndex = registeredProductData.findIndex((item) => normalizeSerial(item?.serialNumber) === serial);
  if (serialIndex < 0) return 1;

  const pageSize = Number(ITEMS_PER_PAGE) > 0 ? Number(ITEMS_PER_PAGE) : 1;
  return Math.floor(serialIndex / pageSize) + 1;
}

// 나의 등록 제품 조회
function fetchMyRegisteredProduct() {
  if (!customerMd5Hash) {
    return Promise.resolve([]);
  }
  openLoadingModal();
  return fetch(CUSTOMER_PROD_VERIFICATION_LIST_ENDPOINT, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      "customerMd5Hash": customerMd5Hash
    })
  })
    .then(async (response) => {
      if (!response.ok) {
        let message = "알 수 없는 오류가 발생했습니다.";
        try {
          const error = await response.json();
          message = error.response_message || message;
        } catch (err) {
          // ignore json parse errors
        }
        throw new Error(message);
      }
      return response.json();
    })
    .catch((error) => {
      console.warn('[AS] 등록 제품 조회 실패:', error?.message || error);
      return [];
    })
    .finally(() => {
      closeLoadingModal();
    });
}

async function showRegisteredProduct(data) {
  const registeredProductCount = document.getElementById('registered-product-count');
  const noProductSection = document.querySelector('#as-form-1 .no-product');
  const hasProductSection = document.querySelector('#as-form-1 .has-product');
  const wrapperMyProduct = document.querySelector('#as-form-1 .wrapper__my_product');

  hasRegisteredProductListLoaded = false;
  registeredProductData = data || [];
  registeredProductCount.textContent = registeredProductData.length;

  const savedSerial = (typeof formData !== 'undefined') ? normalizeSerial(formData?.serialNumber) : '';
  currentRegisteredPage = resolveRegisteredProductPageBySerial(savedSerial);

  // wrapper__my_product 비우기
  wrapperMyProduct.replaceChildren();

  if (registeredProductData.length > 0) {
    noProductSection.classList.add('hidden');
    hasProductSection.classList.remove('hidden');

    renderRegisteredProductPage(currentRegisteredPage);
    renderRegisteredProductPagination();
  } else {
    hasProductSection.classList.add('hidden');
    noProductSection.classList.remove('hidden');
  }

  hasRegisteredProductListLoaded = true;
}

async function renderRegisteredProductPage(page) {
  const wrapper = document.querySelector('.wrapper__my_product');
  wrapper.replaceChildren();

  const start = (page - 1) * ITEMS_PER_PAGE;
  const end = page * ITEMS_PER_PAGE;
  const pageItems = registeredProductData.slice(start, end);

  for (let i = 0; i < pageItems.length; i++) {
    await renderSingleRegisteredProduct(pageItems[i], start + i); // 기존 로직 활용
  }

  // 렌더링 후 선택 상태 복원
  restoreSelectedProduct();
}

// 선택된 제품 상태 복원
function restoreSelectedProduct() {
  // formData에 저장된 serialNumber가 있으면 해당 라디오 버튼 체크
  if (typeof formData !== 'undefined' && formData.serialNumber) {
    const savedRadio = document.querySelector(`input[name="selectProduct"][value="${formData.serialNumber}"]`);

    if (savedRadio) {
      savedRadio.checked = true;

      // 해당 카드에 active 클래스 추가
      const card = savedRadio.closest('.wrap__my_product');
      if (card) {
        document.querySelectorAll('.wrap__my_product').forEach(c => c.classList.remove('active'));
        card.classList.add('active');
      }

      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(1);
      }
    }
  }
}

function renderRegisteredProductPagination() {
  const totalPages = Math.ceil(registeredProductData.length / ITEMS_PER_PAGE);
  const paginationContainer = document.getElementById('registered-product-pagination');
  if (!paginationContainer || totalPages <= 1) return;

  paginationContainer.innerHTML = '';

  // 페이지 변경시 스크롤 이동
  const scrollToTop = () => {
    window.scrollTo({ top: 200, behavior: 'smooth' });
  };

  const createBtn = (label, page, isActive = false) => {
    const btn = document.createElement('button');
    btn.textContent = label;
    if (isActive) btn.classList.add('active');
    btn.addEventListener('click', () => {
      currentRegisteredPage = page;
      renderRegisteredProductPage(page);
      renderRegisteredProductPagination();
      scrollToTop();
    });
    return btn;
  };

  // ◀ Prev
  const prevBtn = document.createElement('button');
  prevBtn.innerHTML = `<img src="${icon_left_line_bk}" alt="prev" width="22" height="22">`;
  prevBtn.disabled = currentRegisteredPage === 1;
  prevBtn.addEventListener('click', () => {
    if (currentRegisteredPage > 1) {
      currentRegisteredPage--;
      renderRegisteredProductPage(currentRegisteredPage);
      renderRegisteredProductPagination();
      scrollToTop();
    }
  });
  paginationContainer.appendChild(prevBtn);

  let startPage = 1;
  if (currentRegisteredPage <= 3) {
    startPage = 1;
  } else if (currentRegisteredPage >= totalPages - 2) {
    startPage = Math.max(1, totalPages - 4);
  } else {
    startPage = currentRegisteredPage - 2;
  }

  const endPage = Math.min(startPage + 4, totalPages);
  for (let i = startPage; i <= endPage; i++) {
    paginationContainer.appendChild(createBtn(i, i, i === currentRegisteredPage));
  }

  // Next
  const nextBtn = document.createElement('button');
  nextBtn.innerHTML = `<img src="${icon_right_line_bk}" alt="next" width="22" height="22">`;
  nextBtn.disabled = currentRegisteredPage === totalPages;
  nextBtn.addEventListener('click', () => {
    if (currentRegisteredPage < totalPages) {
      currentRegisteredPage++;
      renderRegisteredProductPage(currentRegisteredPage);
      renderRegisteredProductPagination();
      scrollToTop();
    }
  });
  paginationContainer.appendChild(nextBtn);
}

async function renderSingleRegisteredProduct(dataItem, index) {
  const wrapperMyProduct = document.querySelector('.wrapper__my_product');

  const itmCd = dataItem.itmCd;
  const colCd = dataItem.colCd;
  const exactSku = `${itmCd}-${colCd}`;

  let matchIndex = allProductData.findIndex((item) => Array.isArray(item.variants) && item.variants.some((variant) => variant.sku === exactSku));

  if (matchIndex === -1) {
    matchIndex = allProductData.findIndex((item) => {
      let itemSku = item.sku && item.sku.split('-')[0];
      return itmCd === itemSku;
    });
  }
  let productFullName = '';
  let representativeImage = '';
  let verifyDate = modifyData("verifyDate", dataItem.verifyDate);
  let hasLink = false;
  let productLinkUrl = '';

  if (matchIndex === -1) {
    if ((!dataItem.productFullName || dataItem.productFullName.trim() === "") && typeof fetchSerialInfo === 'function') {
      const serialResult = await fetchSerialInfo(dataItem.serialNumber);
      if (serialResult) {
        dataItem.productFullName = serialResult.itmNm || "";
      }
    }
    productFullName = modifyData("productFullName", dataItem.productFullName);
    representativeImage = (dataItem.representativeImage && dataItem.representativeImage !== 'N/A')
      ? `url('${dataItem.representativeImage}')`
      : `url('${no_product_image}')`;
  } else {
    const tempItmCd = dataItem.itmCd || '';
    const tempCcolCd = dataItem.colCd || '';
    const dataSku = `${tempItmCd}-${tempCcolCd}`;
    let matchedImageSrc = '';

    for (let variant of allProductData[matchIndex].variants) {
      if (variant.sku === dataSku && variant.image) {
        matchedImageSrc = variant.image;
        break;
      }
    }

    productFullName = modifyData("productFullName", allProductData[matchIndex].title);
    representativeImage = (matchedImageSrc && matchedImageSrc !== 'N/A')
      ? `url('${matchedImageSrc}')`
      : `url('${no_product_image}')`;
    hasLink = true;
    productLinkUrl = `/products/${allProductData[matchIndex].handle}`;
  }

  const temp = `
    <div class="wrap__my_product">
      <div class="header__product">
        <div class="wrap_product_card">
          <div class="tablet_product">
            <div class="img__my_product" style="background-image: ${representativeImage};">
            </div>
            <div class="mobile_product_title title-7">
              <span class="${hasLink ? 'cursor__pointer' : ''}"
                ${hasLink ? `onclick="window.open('${productLinkUrl}','_blank','noopener,noreferrer')"` : ''}>
                ${productFullName}
              </span>
            </div>
          </div>
          <div class="gap__61 my_product_text">
            <div class="title-7 pc_product_title ${hasLink ? 'cursor__pointer' : ''}"
              ${hasLink ? `onclick="window.open('${productLinkUrl}','_blank','noopener,noreferrer')"` : ''}>
              ${productFullName}
            </div>
            <div class="body-3">
              <div class="info-grid">
                <div>제품코드</div>
                <span class="text-tertiary">${dataItem.itmCd}</span>
              </div>
              <div class="info-grid">
                <div>색상코드</div>
                <span class="text-tertiary">${dataItem.colCd}</span>
              </div>
              <div class="info-grid">
                <div>품질보증만료일</div>
                <span class="text-select">${verifyDate}</span>
              </div>
              <div class="info-grid">
                <div>출장비 무상기간</div>
                <span class="text-select">${dataItem?.freemmDate?.split('T')[0] || "-"}</span>
              </div>
              <div class="info-grid">
                <div>시리얼넘버</div>
                <span class="text-tertiary">${dataItem.serialNumber}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="delete_my_product_wrapper">
          <input type="radio" name="selectProduct" id="product-${dataItem.serialNumber}" value="${dataItem.serialNumber}" />
          <label for="product-${dataItem.serialNumber}" class="label__radio__as"></label>
        </div>
      </div>

      <div class="space__between find-repair">
        <div class="body-2">부품 찾아보기</div>
      </div>

      <div class="swiper product__swiper product__swiper-${index}" style="padding-bottom: 0;">
        <div class="swiper-wrapper row__self_repair">
          <div class="swiper-slide wrap__repair_thumbnail">
            <div class="repair__thumbnail"></div>
            <div class="body-4 product_name"></div>
            <div class="caption-2 text-select">회원 할인가</div>
            <div class="body-3 product_price">원</div>
            <div class="body-3 before_product_price">원</div>
          </div>
        </div>
      </div>
    </div>
  `;

  wrapperMyProduct.insertAdjacentHTML("beforeend", temp);

  // 방금 생성된 카드에만 이벤트 등록 (EasyRepair 로드 전에 바인딩)
  const currentCard = wrapperMyProduct.lastElementChild;
  const radio = currentCard?.querySelector('input[type="radio"]');
  const activateSelection = () => {
    if (!radio) return;

    radio.checked = true;

    document.querySelectorAll('.wrap__my_product').forEach(c => c.classList.remove('active'));
    currentCard.classList.add('active');

    if (typeof updateFormData === 'function') {
      updateFormData('serialNumber', radio.value);
    }

    if (typeof checkNextButtonState === 'function') {
      checkNextButtonState(1);
    }
  };

  if (currentCard && radio) {
    // 카드 클릭시 라디오 선택 + active 클래스 추가
    currentCard.addEventListener('click', (e) => {
      // swiper 영역이나 링크 클릭시 제외
      if (e.target.closest('.product__swiper') || e.target.closest('a') || e.target.closest('[onclick]')) {
        return;
      }
      activateSelection();
    });

    // 라디오 버튼 직접 클릭/변경시에도 active 클래스 추가
    radio.addEventListener('change', activateSelection);
  }

  // EasyRepair 처리
  const easyrepairData = await myProductEasyrepair(dataItem.itmCd);
  const productSwiper = currentCard?.querySelector(`.product__swiper-${index}`);
  if (!productSwiper) return;
  productSwiper.replaceChildren();

  if (easyrepairData?.length > 0) {
    productSwiper.insertAdjacentHTML("beforeend", `<div class="swiper-wrapper row__self_repair"></div>`);

    for (let repairItem of easyrepairData) {
      const findProduct = findProductByTitle(repairItem.title);
      const variant = findProduct?.variants?.[0] || {};
      const price = typeof variant.price === 'string' ? variant.price : '';
      const specialPrice = typeof variant.special_price === 'string' ? variant.special_price : '';
      const start = variant.event_start_dt ? new Date(variant.event_start_dt) : null;
      const end = variant.event_end_dt ? new Date(variant.event_end_dt) : null;
      const now = new Date();

      const priceNumber = price ? parseFloat(price.replace(/,/g, '')) : NaN;
      const specialPriceNumber = specialPrice ? parseFloat(specialPrice.replace(/,/g, '')) : NaN;
      const hasEventRange = start && end && !isNaN(start) && !isNaN(end);
      const isEvent = hasEventRange && now >= start && now <= end;
      const isDiscount =
        isEvent &&
        Number.isFinite(priceNumber) &&
        Number.isFinite(specialPriceNumber) &&
        priceNumber > specialPriceNumber;

      const priceTag = isDiscount
        ? `
          <div class="caption-2 text-select">회원할인가</div>
          <div class="body-3 product_price">${specialPriceNumber.toLocaleString()}원</div>
          <div class="body-3 before_product_price">${priceNumber.toLocaleString()}원</div>`
        : (Number.isFinite(priceNumber)
            ? `<div class="body-3 product_price">${priceNumber.toLocaleString()}원</div>`
            : `<div class="body-3 product_price">가격 정보 없음</div>`);

      const featuredImage = repairItem.featured_image && repairItem.featured_image !== 'N/A'
        ? `url('${repairItem.featured_image}')`
        : 'none';

      const swiperSlide = `
        <div class="swiper-slide wrap__repair_thumbnail my-product-block-cursor"
          onclick="window.open('/products/${repairItem.handle}','_blank','noopener,noreferrer')">
          <div class="repair__thumbnail" style="background-image: ${featuredImage};"></div>
          <div class="body-4 product_name">${repairItem.title}</div>
          ${priceTag}
        </div>
      `;

      productSwiper.querySelector('.swiper-wrapper').insertAdjacentHTML("beforeend", swiperSlide);
    }

    productSwiper.parentElement.querySelector('.find-repair').insertAdjacentHTML("beforeend", `
      <div class="swiper-navigation">
        <img class="swiper-button-prev swiper-button-prev-${index}" src="${icon_arrow_left_22}" alt="icon-arrow-left">
        <img class="swiper-button-next swiper-button-next-${index}" src="${icon_arrow_right_22}" alt="icon-arrow-right">
      </div>
    `);
  } else {
    productSwiper.classList.add('mypage_no_easyrepair');
    productSwiper.style.backgroundImage = `url('${no_easyrepair}')`;
    productSwiper.innerHTML = `
      <div class="mypage_no_easyrepair_text">호환 가능한 이지리페어 제품이 없습니다.</div>
      <div class="swiper-wrapper row__self_repair" style="visibility: hidden;">
        <div class="swiper-slide wrap__repair_thumbnail">
          <div class="repair__thumbnail"></div>
          <div class="body-4 product_name">.</div>
          <div class="caption-2 text-select">.</div>
          <div class="body-3 product_price">.</div>
          <div class="body-3 before_product_price">.</div>
        </div>
      </div>
    `;
  }

  if (typeof Swiper !== 'undefined') {
    new Swiper(`#mypage_my_product .swiper.product__swiper.product__swiper-${index}`, {
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 7,
      navigation: {
        prevEl: `.swiper-button-prev-${index}`,
        nextEl: `.swiper-button-next-${index}`,
      },
    });
  } else {
    console.warn('[AS] Swiper 라이브러리를 찾을 수 없습니다. 슬라이더 초기화를 건너뜁니다.');
  }
}

// 이지리페어 정보 뽑기
async function myProductEasyrepair(item_code) {
  let temp = await searchByProductCode(item_code);
  let codeData = temp.data || [];
  let matchData = [];

  if (codeData.length > 0) {
    codeData.forEach((code) => {
      easyrepairListData.forEach((easyrepair) => {
        if (code == easyrepair.repair_prod_code) {
          matchData.push(easyrepair.data);
        }
      })
    })
  }
  return matchData;
}

// 제품 코드로 검색시 이지리페어 정보
async function searchByProductCode(param) {

  return fetch('https://sidiz-shopify.sidiz.com/v1/easy-repair/mapping', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({
      "code": param
    }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('error');
      }
      return response.json();
    })
    .catch(error => {
      return [];
    });
}

// 제품 등록 모달 - 모달을 여는 함수
function openProductRegisterModal() {
  if (window.ProductRegisterModalLegacy && typeof window.ProductRegisterModalLegacy.open === 'function') {
    window.ProductRegisterModalLegacy.open({
      apiEndpoint: SERIAL_REGISTRATION_ENDPOINT,
      successMode: 'simple',
      successMessage: '정품 등록이 완료되었습니다.<br/>시디즈가 제공하는 품질 보증 서비스를 경험해 보세요.'
    });
    return;
  }
  if (window.ProductRegisterModalDev && typeof window.ProductRegisterModalDev.open === 'function') {
    window.ProductRegisterModalDev.open({
      apiEndpoint: SERIAL_REGISTRATION_ENDPOINT,
      apiBase: `${AS_PROXY_BASE_URL}/v1`
    });
  }
}

// 데이터 처리
function modifyData(name, value) {
  if (name == "productFullName") {
    if (!value || value == "N/A") {
      productFullName = "";
    }
    else {
      productFullName = value;
    }
    return productFullName;
  }
  else if (name == "representativeImage") {
    if (!value || value == "N/A") {
      // representativeImage = "대체 이미지 자리";
      representativeImage = "";
    }
    else {
      representativeImage = value;
    }
    return representativeImage;
  }
  else if (name == "verifyDate") {
    if (value) {
      verifyDate = value.split('T')[0];
    }
    else {
      verifyDate = "";
    }
    return verifyDate;
  }
}

// 이름으로 상품 정보 찾기
function findProductByTitle(targetTitle) {
  // allProductData 배열을 순회하며 일치하는 찾기
  for (const product of allProductData) {
    if (product.title) {
      if (product.title === targetTitle) {
        return product;
      }
    }
  }

  return null;
}
